import SearchInput from '@Components/SearchInput'
import { hubMembers } from '@Modules/group/atoms'
import User from '@Modules/group/users/User'
import GroupWrapper from '@Modules/group/GroupWrapper'
import { hubAtom, restApiAtom, sessionAtom, useAddAlert } from '@Modules/hubs/atoms'
import messages from '@Modules/hubs/main/messages'
import HubSignIn from '@Modules/subLogin'
import debounce from 'lodash.debounce'
import { useRouter } from 'next/router'
import { default as React, useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import { useRecoilState, useRecoilValue } from 'recoil'
import styled from 'styled-components'
import media from '@Styles/media'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'

type props = {}

const Collaborators: React.FC<props> = (props: props) => {
  const sessionResponse = useRecoilValue(sessionAtom)
  const hubResponse = useRecoilValue(hubAtom)
  const router = useRouter()
  const [currentText, setCurrentText] = useState(router.query.q ?? '')
  const [currentHubMembers, setCurrentHubmembers] = useRecoilState(hubMembers)
  const intl = useIntl()
  const restApi = useRecoilValue(restApiAtom)
  const addAlert = useAddAlert()
  const [isFetched, setIsFetched] = useState(false)

  if (
    sessionResponse.error ||
    !sessionResponse?.data ||
    !hubResponse?.data ||
    hubResponse?.status == 403
  ) {
    return <HubSignIn />
  }
  const hub = hubResponse.data

  const fetchUsers = async (hubId: string, searchText: string | string[]) => {
    const resp = await restApi.fetchMembers(hubId, {
      role: 'collaborator,moderator,owner',
      order_by: 'name',
      q: searchText,
    })

    if (resp.error) {
      addAlert({
        message: `Failed to fetch users`,
        type: 'DANGER',
      })
      return
    }
    setCurrentHubmembers(resp)
    setIsFetched(true)
  }

  const fetchNextPage = async (hubId: string) => {
    if (!currentHubMembers.nextPageQuery) {
      return
    }
    const resp = await restApi.fetchMembers(hubId, currentHubMembers.nextPageQuery)
    if (resp.error) {
      addAlert({
        message: `Failed to fetch users`,
        type: 'DANGER',
      })
      return
    }
    setCurrentHubmembers({ ...currentHubMembers, data: [...currentHubMembers.data, ...resp.data] })
  }

  useEffect(() => {
    fetchUsers(hub.id, currentText)
  }, [currentText])

  const searchDebounce = useCallback(
    debounce(async (searchString: string) => {
      setCurrentText(searchString)
    }, 500),
    []
  )
  return (
    <GroupWrapper hub={hub}>
      <StyledSearchInput
        placeholder={intl.formatMessage(messages.searchUsers)}
        defaultValue={router.query.q ?? ''}
        onChange={(ev: any) => searchDebounce(ev.target.value)}
      />

      {currentHubMembers.data.length
        ? currentHubMembers.data.map((user, index) => (
            <User
              key={index}
              user={user}
              hub={hub}
              intl={intl}
              session={sessionResponse}
              className={'px-collaborator'}
              itemProp={'collaborator'}
            />
          ))
        : isFetched && (
            <EmptyContainer>
              <HubFormattedMessage {...messages.noUsers} />
            </EmptyContainer>
          )}
      <Waypoint onEnter={() => fetchNextPage(hub.id)} />
    </GroupWrapper>
  )
}

const EmptyContainer = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeLarge};
  color: ${({ theme }) => theme.colors.grayMedium};
  padding: ${({ theme }) => theme.sizes.gutterLarge} 0;
`
const StyledSearchInput = styled(SearchInput)`
  width: 50%;
  ${media.smallerThanLargeScreen`
    width:100%;
  `};
`

export default Collaborators
